import React from 'react';
import Seat from './Seat';
import WagonDoor from './WagonDoor';
import WagonToilet from './WagonToilet';
import WagonTable from './WagonTable';

function Wagon({
  seatColumns,
  topSeatColumns,
  seats,
  chosenSeats,
  setChosenSeats,
  wagonNumber,
  reserveSeat,
  unReserveSeat,
  topTablePositions,
  bottomTablePositions,
  toiletClassname,
  className,
  topLeftToilet,
  bottomLeftToilet,
}) {
  // eslint-disable-next-line max-len
  const isTopTablePosition = (columnIndex) => topTablePositions && topTablePositions.includes(columnIndex);

  // eslint-disable-next-line max-len
  const isBottomTablePosition = (columnIndex) => bottomTablePositions && bottomTablePositions.includes(columnIndex);

  return (
    <div>
      <div className="wagon flex flex-col justify-between items-center">
        <div className="wagon-floor">
          <h2>I</h2>
        </div>
        <WagonDoor className="wagon-feature mxp absolute top-[40%] right-[15px]" />
        <WagonDoor className="wagon-feature mxp absolute top-[40%] left-[15px]" />
        <div
          className="wagon-feature mr-2.5 ml-5 flex items-center"
        >
          {topLeftToilet
          && (
            <WagonToilet
              className="flex gap-x-2 ml-2.5"
            />
          )}
          {topSeatColumns && topSeatColumns.map((column, columnIndex) => (
            // eslint-disable-next-line react/no-array-index-key
            <React.Fragment key={columnIndex}>
              <div className="seat-column">
                {column.map((seatIndex, index) => (
                  <Seat
                    key={seatIndex}
                    seat={seats?.[seatIndex]}
                    chosenSeats={chosenSeats}
                    setChosenSeats={setChosenSeats}
                    wagonNumber={wagonNumber}
                    reserveSeat={reserveSeat}
                    unReserveSeat={unReserveSeat}
                    noDirection
                    bottom={index === column.length - 1}
                  />
                ))}
              </div>
              {isTopTablePosition(columnIndex) && (
              <WagonTable
                className="wagon-feature !ml-[15px]"
                style={{ display: 'flex', alignItems: 'center' }}
              />
              )}
            </React.Fragment>
          ))}
          <WagonToilet className={`flex gap-x-2 ml-2.5 ${toiletClassname}`} />
        </div>

        <div
          className="flex gap-x-2"
        >
          <div
            className={`wagon-feature mr-2.5 ml-5 flex items-center ${className}`}
          >
            {bottomLeftToilet
                && (
                  <WagonToilet className="flex gap-x-2 ml-2.5" />
                )}
            {seatColumns.map((column, columnIndex) => (
              // eslint-disable-next-line react/no-array-index-key
              <React.Fragment key={columnIndex}>
                <div className="seat-column">
                  {column.map((seatIndex, index) => (
                    <Seat
                      key={seatIndex}
                      seat={seats?.[seatIndex]}
                      chosenSeats={chosenSeats}
                      setChosenSeats={setChosenSeats}
                      wagonNumber={wagonNumber}
                      reserveSeat={reserveSeat}
                      unReserveSeat={unReserveSeat}
                      noDirection
                      bottom={index === column.length - 1}
                    />
                  ))}
                </div>
                {isBottomTablePosition(columnIndex) && (
                  <WagonTable
                    className="wagon-feature !ml-[15px]"
                    style={{ display: 'flex', alignItems: 'center' }}
                  />
                )}
              </React.Fragment>
            ))}
            <WagonToilet className="flex gap-x-2 ml-2.5" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Wagon;
